<script>
export default {
  name: 'SbTableRowPasser',
  components: {},
  directives: {},
  filters: {},
  mixins: [],
  provide() {
    return {
      sbTableRow: this.sbTableRow,
    };
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    sbTableRow: {
      row: {},
      index: -1,
    },
  }),
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    this.sbTableRow.row = this.row;
    this.sbTableRow.index = this.index;
  },
  beforeMount() {},
  mounted() {},
  beforeUnmount() {},
  unmounted() {},
  beforeUpdate() {},
  updated() {},
  methods: {},
  render() {
    return this.$slots.default();
  },
  i18n: { messages: {} },
};
</script>
